import axios from 'axios';
import apisUrls from '../urls';

const createClientApi = (values, edit = false) => {
  const url = !edit ? apisUrls?.createClient : apisUrls?.updateClient;

  return axios.post(url, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default createClientApi;
